import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Leaf, Eye, EyeOff } from "lucide-react";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#0F1612' }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Leaf className="w-6 h-6 text-[#D97A46]" />
            <span className="font-serif text-2xl font-bold text-[#F2F4F3]">PIIKK Agro Farm Fresh Mushrooms</span>
          </div>
          <h1 className="font-serif text-3xl font-bold text-[#F2F4F3]">Admin Login</h1>
          <p className="text-sm text-[#A8BCAE] mt-1">Manage your mushroom store</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-medium text-[#A8BCAE] mb-1.5">Email</label>
            <input
              data-testid="admin-email-input"
              type="email" required value={email} onChange={e => setEmail(e.target.value)}
              placeholder="admin@piikk.com"
              className="w-full px-4 py-3 rounded-xl border border-[#273A2F] text-[#F2F4F3] text-sm placeholder-[#A8BCAE] focus:outline-none focus:border-[#D97A46]/60 transition-colors"
              style={{ backgroundColor: '#16201A' }}
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-[#A8BCAE] mb-1.5">Password</label>
            <div className="relative">
              <input
                data-testid="admin-password-input"
                type={showPw ? "text" : "password"} required value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-3 pr-10 rounded-xl border border-[#273A2F] text-[#F2F4F3] text-sm placeholder-[#A8BCAE] focus:outline-none focus:border-[#D97A46]/60 transition-colors"
                style={{ backgroundColor: '#16201A' }}
              />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#A8BCAE]">
                {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          {error && <p className="text-red-400 text-sm" data-testid="admin-login-error">{error}</p>}

          <button
            data-testid="admin-login-submit"
            type="submit" disabled={loading}
            className="w-full py-3 rounded-xl font-semibold text-white transition-all hover:scale-[1.02] disabled:opacity-60"
            style={{ backgroundColor: '#D97A46' }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
